import Vue from 'vue'
import TomSelect from 'tom-select'
import _ from 'lodash'

// Vue.directive('sidebar', {
//     inserted(el) {
//         // Toggle the side navigation
//         $("#sidebarToggle").on("click", function (e) {
//             e.preventDefault()
//             $("body").toggleClass("sb-sidenav-toggled")
//         });
//     }
// })

Vue.directive('table-group', {
    update: _.debounce(function (el, binding, vnode, oldVnode) {
        if (vnode != oldVnode) {
            let table = el.getElementsByTagName('table').item(0)
            //console.log(table.rows.length)
            if (table.rows.length > 1) {
                //console.log(table)
                let currentGroup: HTMLTableRowElement = null
                let row: HTMLTableRowElement = null
                for (row of table.rows) {
                    if (!row.dataset['grouped']) {
                        if (!currentGroup) {
                            currentGroup = row
                            currentGroup.cells[0].rowSpan = currentGroup.cells[0].rowSpan || 1
                        } else if (row.cells[0].innerText.trim() && currentGroup.cells[0].innerText.trim()) {
                            if (row.cells[0].innerText.trim() === currentGroup.cells[0].innerText.trim()) {
                                // console.log(row.cells[0].innerText.trim())
                                // console.log(currentGroup.cells[0].innerText.trim())
                                currentGroup.cells[0].rowSpan += 1
                                row.cells[0].remove()
                                row.dataset['grouped'] = 1
                            } else {
                                currentGroup = row
                                currentGroup.cells[0].rowSpan = currentGroup.cells[0].rowSpan || 1
                            }
                        }
                    }
                }
            }
        }
    }, 200)
})